module.exports = __webpack_public_path__ + "img/404_background.40638f6.jpg";